import React, { useState } from 'react';
import text from '../lib/dictionary.json';
import { useAuth } from '../AuthProvider';
import './modal.css';
import { AccountIcon, DashedLineSeparator, EmailIcon, KeyIcon, NameIcon, PhoneIcon } from '../Icons';
import { post } from '../services/http';


const DANGER = '#DC2626';

const MyProfile = ({ state, setState, mandatory, backgroundColor, color }) => {
    const { lang, user, setUser, setAlertState } = useAuth();
    const [model, setModel] = useState({
        name: user.name,
        email: user.email,
        phone: user.phone,
        role: user.role,
        type: user.type
    })

    const [isSaving, setIsSaving] = useState(false);
    const updateProfile = async () => {
        setIsSaving(true);
        const res = await post(`/user/update/${user.id}`, {
            name: model.name,
            phone: model.phone,
            email: user.email
        })
        
        setIsSaving(false);
        setUser(res.data);
        setAlertState({
            open: true,
            type: res.success ? 'success' : 'error',
            message: res.message
        })
    }
    return (
        <div id='modal' >
            <div id='popup' onClick={(e) => e.stopPropagation()} style={{
                width: '45rem',
                height: 'fit-content',
            }}>
                <div style={{
                    width: '100%',
                    background: `
                     radial-gradient(120% 80% at 50% 0%,
                     var(--app-gradient-1) 0,
                     var(--app-gradient-2) 30%,
                     var(--root-background-color) 60%)`,
                    color: color || 'var(--cell-color)',
                    // animation: 'scale-anim-center .3s linear'
                }}>
                    <div className='modal-header' style={{
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        width: '100%',
                        paddingBottom: 0
                    }}>
                        <h2 style={{
                            textAlign: lang === 'en' ? 'left' : 'right',
                            fontSize: 'var(--large)', fontWeight: 'bold', color: '#111827'
                        }}>{text[lang]['user-details']}</h2>
                        {/* <p style={{
                            fontSize: 'var(--small)',
                            color: '#576573'
                        }}>{text[lang]['change-password-description']}</p> */}
                        <div style={{
                            width: '45rem',
                            padding: '0 2.75rem'
                        }}>
                            <DashedLineSeparator />
                        </div>
                    </div>
                    <div className='' style={{
                        width: '100%',
                        padding: '0 2.75rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        marginTop: '2rem'
                    }}>
                        <FormItem label={text[lang]['name']} value={model?.name || ''} lang={lang}
                            icon={<NameIcon />}
                            OnChange={(e) => setModel({ ...model, name: e.target.value })}
                        />

                        <FormItem label={text[lang]['email']} value={model?.email || ''} lang={lang}
                            icon={<EmailIcon />}
                            type='email'
                            OnChange={(e) => setModel({ ...model, email: e.target.value })}
                        />

                        <FormItem label={text[lang]['phone']} value={model?.phone || ''} lang={lang}
                            icon={<PhoneIcon />}

                            OnChange={(e) => setModel({ ...model, phone: e.target.value })}
                        />

                        <FormItem label={text[lang]['user-role']} value={model?.role || ''} lang={lang}
                            icon={<KeyIcon />}
                            readOnly={true}
                        />

                        <FormItem label={text[lang]['account-type']} value={model?.type || ''} lang={lang}
                            icon={<AccountIcon />}
                            readOnly={true}

                        />
                    </div>
                    <div className='' style={{
                        // flexDirection: lang === 'en' ? 'row' : 'row-reverse',
                        display: 'flex',
                        margin: '2.125rem',
                        justifyContent: 'flex-end',
                        gap: '0.5rem'
                    }}>
                        {!mandatory && <button className='modal-btn modal-cancel-btn' onClick={() => setState({ open: false, userId: 0 })}>{text[lang]['cancel']}</button>}
                        <button
                            className='modal-btn modal-add-btn'
                            onClick={updateProfile}
                            disabled={isSaving}
                            style={{
                                // opacity: canUpdate ? 1 : 0.5,
                                // cursor: canUpdate ? 'pointer' : 'not-allowed'
                            }}
                        >
                            {isSaving ? '...' : text[lang]['update']}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const FormItem = ({ label, value, lang, OnChange, type = 'text', error, icon, readOnly }) => {
    return (
        <div className='form-item' style={{ width: '100%', flexDirection: 'column', display: 'flex', alignItems: lang === 'en' ? 'flex-start' : 'flex-end', gap: 8 }}>
            <div style={{ width: '100%' }}>
                <label className='' style={{
                    fontSize: 'var(--medium)',
                    fontWeight: 'bold',
                    color: '#111827',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.25rem'
                }}>{icon}{label}</label>

                <div className='field-wrapper' style={{
                    width: '100%',
                    marginTop: 2,
                    position: 'relative'
                }}>
                    <input type={type} className=''
                        placeholder={text[lang]['password-label']} value={value}
                        style={{
                            textAlign: lang === 'en' ? 'left' : 'right',
                            height: '3.188rem',
                            borderRadius: '0.5rem',
                            border: error ? `1px solid ${DANGER}` : '1px solid #829AB1',
                            width: '100%',
                            padding: '0 1rem',
                            background: 'rgba(255,255,255,0.8)'
                        }}
                        onChange={OnChange}
                        disabled={readOnly}
                    />

                    {/* <span className='search-icon' style={{
                        position: 'absolute',
                        right: lang === 'en' ? '5%' : 'unset',
                        left: lang === 'en' ? 'unset' : '5%',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'auto',
                        cursor: 'pointer',
                        display: 'flex'
                    }}
                        onClick={setShow}
                    >
                        {show ? <ShowIcon /> : <HideIcon />}
                    </span> */}
                </div>
                {/* إضافة رسالة الخطأ أو الهيلبر بنفس الستايل */}
                {/* {error ? (
                    <div style={{ color: DANGER, fontSize: 'var(--x-small)', marginTop: '4px' }}>{error}</div>
                ) : helper && (
                    <div style={{ color: '#6B7280', fontSize: 'var(--x-small)', display: 'flex', gap: '0.313rem', marginTop: '4px' }}>
                        <CheckIcon />
                        <span>{helper}</span>
                    </div>
                )} */}
            </div>
        </div>
    );
}

export default MyProfile;